module.exports = __webpack_public_path__ + "img/hr-level3addon_dead.4bcf66ae.png";